import { Component } from '@angular/core';
import { DrugService } from '../services/drug.service';

@Component({
  selector: 'app-drug-pagination',
  templateUrl: './drug-pagination.component.html'
})
export class DrugPaginationComponent {
  constructor(public service: DrugService) { }

  onPaginate(page: number) {
    this.service.currentPage = page;
    this.service.search();
  }
}
